__turbopack_context__.v({
  "hint": "NX64bW_hint",
  "iconBox": "NX64bW_iconBox",
  "label": "NX64bW_label",
  "leadingArrow": "NX64bW_leadingArrow",
  "link": "NX64bW_link",
  "text": "NX64bW_text",
});
